module.exports = __webpack_public_path__ + "img/banner_toy.c43fafdb.png";